import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import logo from "../Assets/Images/codivas-dark.png";
import history from "../routes/helper/history";
import CONSTANTS from "../constants";

const Copyright = styled.span`
  padding: 1rem 0 1rem 1rem;
  align-self: flex-end;
  color: $color-font;
`;

const Footers = styled.footer`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-content: center;
  position: sticky;
  bottom: 0;
  background-color: white;
  padding: 1rem;
  img {
    position: absolute;
    inset: 0;
    margin: auto;
    @media screen and (max-width: 1686px) {
      position: relative;
  }
  }
  ${Copyright} {
    padding: 1rem 1rem 1rem 1rem;
    align-self: flex-end;
    color: #202020;
  }
  .footer-links  li{
    margin-left: 20px;
    font-size:10px;
  }
  a{
    font-size: 20px;
    cursor: pointer;
  }
  @media screen and (max-width: 1686px) {
    flex-direction: column;
  }
`;

function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <Footers>
      <img src={logo} width={110} alt="Logo Codivas" />
      <span className="footer-links">
      <a href="https://codivas.com.br"  target="_blank" rel="noopener noreferrer">Codiva © {currentYear} </a>

      </span>
      <ul className="footer-links">
      <li>
          <a onClick={() => history.push(CONSTANTS.APP.POLITICA) }> Política de privacidade </a>
        </li>
        <li>
          <a onClick={() => history.push(CONSTANTS.APP.TERMOS) }>Termos e condições</a>
        </li>
      </ul>
    </Footers>
  );
}
export default Footer;
